export default __webpack_public_path__ + "static/ActivityCardTable-9b3c772e625092d0be47874204dd15ec.png";